/**
 * @desc 代办任务查询移动端
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.PersonalTaskDTO>>> {
  return defHttp.get({
    url: '/wap/personal/search',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.PersonalTaskDTO>>> {
  return defHttp.get({
    url: '/mock/wap/personal/search',
  });
}
